// src/router/autoRouteMappingComponents.js

// 1) 허용 디렉터리
const ALLOWED_DIRS = new Set(['park']);

// 2) 옵션
const KEEP_NESTED_PATHS = true;
const FORCE_LOWERCASE_URL = false;

// 3) components 전체 스캔 (Webpack)
const requireComponents = require.context('@/components', true, /\.vue$/);

// 4) routePath -> 로더함수 매핑
const routeLoaders = {};

requireComponents.keys().forEach((key) => {
  // key 예) './park/parkCheck.vue' or './park/sub/RegistrationPark.vue'
  const m = key.match(/^\.\/([^/]+)\/(.+)\.vue$/);
  if (!m) return;

  const [, topDir, restPath] = m;
  if (!ALLOWED_DIRS.has(topDir)) return;

  let routePath;
  if (KEEP_NESTED_PATHS) {
    routePath = `/${topDir}/${restPath}.do`;     // /park/sub/Intro.do
  } else {
    const fileName = restPath.split('/').pop();  // /park/Intro.do
    routePath = `/${topDir}/${fileName}.do`;
  }

  if (FORCE_LOWERCASE_URL) routePath = routePath.toLowerCase();

  // 🔑 핵심: 경로 문자열이 아니라 로더 함수를 저장
  if (!routeLoaders[routePath]) {
    routeLoaders[routePath] = () =>
      Promise.resolve(requireComponents(key)).then((m) => m.default);
  }
});

export default routeLoaders;
